import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Redirect} from "react-router-dom";

export default function(ComposedComponent) {
  class Authentication extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    render() {
      if (!this.props.authenticated) {
        return <Redirect to="/" />;
      }
      if (this.props.authenticated) {
        return <ComposedComponent {...this.props} />;
      }
      return null;
    }
  }

  function mapStateToProps(state) {
    return { authenticated: state.auth };
  }

  return connect(mapStateToProps)(Authentication);
}